<script>
    import { reportDownloadWin32, reportDownloadMacOs } from "../statsclient";

    let win32Click = () => reportDownloadWin32();
    let macOsClick = () => reportDownloadMacOs();
</script>

<style>
    .container {
        height: 90vh;
        width: 100%;
        padding: 50px 20px;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;
    }

    @media (min-width: 750px) {
		.container {
            max-height: 90vw;
		}
	}

    .startInstruction {
        font-family: monospace;
        max-width: 600px;
        padding: 15px 20px;
        font-size: 13px;
        border: 1px solid #98D4FF;
        border-radius: 5px;
        background-color: #FFFFFF22;
        line-height: 140%;
    }

    .buildTitle {
        width: 100%;
		text-align: center;
        font-weight: 700;
        letter-spacing: 4px;
        font-size: 20px;
        line-height: 110%;
        margin-bottom: 20px;
    }

    .downloadTitle {
        font-weight: 700;
        letter-spacing: 4px;
        font-size: 20px;
        line-height: 110%;
    }

    .orText {
        width: 100%;
		text-align: center;
        margin-top: 30px;
        margin-bottom: 30px;
    }

    .version {
        opacity: 0.5;
        font-size: 12px;
        text-align: center;
        font-weight: 700;
        line-height: normal;
        position: relative;
        top: 3px;
    }

    .dists {
		width: 100%;
        max-width: 480px;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
		justify-content: center;
    }

    .dist {
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        margin-left: 15px;
		margin-right: 15px;  
        cursor: pointer;  
    }

    @media (max-width: 500px) {
		.dists {
            flex-flow: column nowrap;
		}
        .dist {
            margin-top: 20px;
        }
	}

    .conditions {
        max-width: 600px;
        font-size: 10px;
        opacity: 0.5;
        text-align: center;
        line-height: 150%;
        margin-top: 20px;
    }

    .conditions a {
        text-decoration: underline;
    }

    .dists img {
        height: 20px;
    }
</style>

<div class="container" id="download" data-aos="fade-in">
    <div class="buildTitle">BUILD FROM SOURCE</div>
    <div class="startInstruction">
        git clone https://github.com/bognikol/httpiness.git<br/>
        cd httpiness<br/>
        npm run start:prod:clean<br/>
    </div>
    <div class="orText">or</div>
	<div class="dists">
        <div class="downloadTitle">DOWNLOAD NOW</div>
        <div class="version">v1.4.2</div>
        <div style="flex: 1 1 1px"></div>
        <a class="download-client" on:click="{win32Click}" href="./download/httpiness_win_x64_1.4.2.exe">
            <div class="dist">
                <img src="./images/distributions/win32.svg" alt="Windows" />
            </div>
        </a>
        <a class="download-client" on:click="{macOsClick}" href="./download/httpiness_mac_x64_1.4.2.dmg">
            <div class="dist">
                <img src="./images/distributions/macos.svg" alt="macOS" style="cursor:pointer; height: 15px; margin-top: 2px; margin-bottom: 3px;" />
            </div>
        </a>
    </div>
    <div class="conditions">
        By downloading httpiness, you agree to 
        <a href="#/legal/terms-and-conditions" target="_blank">Terms and Conditions</a> and 
        <a href="#/legal/privacy-policy" target="_blank">Privacy Policy</a>.
    </div>
</div>
